<template>
  <div>
    <div class="card-item" :class="{ 'card-item--active': configTarja && configTarja.id_cronometro === item.id }">
      <!-- Body -->
      <div class="card-item__body">
        <div class="card-item__title" style="font-size: 1.1rem; font-weight: 600;">
          {{ item.dsc_titulo }}
        </div>

        <div class="card-item__info">
          {{ item.dsc_descricao }}
        </div>

        <div class="cronometro-timer">
          <span class="cronometro-timer__display">
            {{ item.tempo.split(":").at(0) }}:{{ item.tempo.split(":").at(1) }}:{{ item.tempo.split(":").at(2) }}
          </span>
        </div>

        <div class="card-item__meta">
          <span>{{ formatDate(item.created_at) }}</span>
          <span class="meta-separator">&bull;</span>
          <span>{{ formatHour(item.created_at) }}</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="card-item__actions">
        <v-tooltip left color="surface_neutral_selected">
          <template v-slot:activator="{ on, attrs }">
            <button
              class="card-action-box card-action-box--move"
              v-bind="attrs"
              v-on="on"
              @click.prevent="removerCronometroExibicao"
             aria-label="Remover cronômetro da exibição.">
              <v-icon>mdi-arrow-left</v-icon>
            </button>
          </template>
          <span>Remover cronômetro da exibição.</span>
        </v-tooltip>

        <ModalEditarCronometro
          :cronometro-data="item"
          :isFavoritaTab="$store.state.cronometros.flg_favorita"
          :currentPage="pageAprovada"

        />

        <v-tooltip
          v-if="configTarja && configTarja.id_cronometro === item.id"
          left
          color="surface_neutral_selected"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              class="card-action-box"
              :aria-label="!isCronometroPaused ? 'Pausar cronômetro' : 'Continuar cronômetro'"
              v-bind="attrs"
              v-on="on"
              @click="handleClickPlayPause"
            >
              <v-icon v-if="isCronometroPaused">mdi-play</v-icon>
              <v-icon v-else>mdi-pause</v-icon>
            </button>
          </template>
          <span>{{ !isCronometroPaused ? "Pausar cronômetro" : "Continuar cronômetro" }}</span>
        </v-tooltip>

        <v-tooltip
          v-if="configTarja && configTarja.id_cronometro === item.id"
          left
          color="surface_neutral_selected"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              class="card-action-box"
              v-bind="attrs"
              v-on="on"
              @click="handleResetTimerCronometro"
             aria-label="Resetar cronômetro">
              <v-icon>mdi-restart</v-icon>
            </button>
          </template>
          <span>Resetar cronômetro</span>
        </v-tooltip>
      </div>
    </div>

    <!-- Tarja controls -->
    <div class="card-tarja-actions">
      <ModalExibirCronometroTarja
        v-if="!configTarja || configTarja.id_cronometro !== item.id"
        :codProducao="item.cod_producao"
        :id_cronometro="item.id"
        @change="changeIsSelectedToTarja(item.id, item.cod_producao)"
      />
      <ModalRemoverCronometroTarja
        v-if="configTarja && configTarja.id_cronometro === item.id"
        :codProducao="item.cod_producao"
        :id-cronometro="item.id"
        @change="changeIsSelectedToTarja(null, item.cod_producao)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { formatDate, formatHour } from "@/utils/dateUtils";
import ModalEditarCronometro from "@/components/Modal/Cronometro/ModalEditarCronometro.vue";
import ModalExibirCronometroTarja from "@/components/Modal/Cronometro/ModalExibirCronometroTarja.vue";
// import ModalExibirCronometroNaTarjaFullScreen from "@/components/Modal/Cronometro/ModalExibirCronometroNaTarjaFullScreen.vue";
import ModalRemoverCronometroTarja from "@/components/Modal/Cronometro/ModalRemoverCronometroTarja.vue";
export default {
  props: {
    item: Object,
    getCronometroEmExibicao: Function,
    getCronometrosProducao: Function,
    pageAprovada: Number,
    cod_pasta: Number,
  },
  components: {
    ModalExibirCronometroTarja,
    // ModalExibirCronometroNaTarjaFullScreen,
    ModalRemoverCronometroTarja,
    ModalEditarCronometro,
  },
  data() {
    return {
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      isSelectedToTarja: false,
      dialogRemoverNoticiaModerada: false,
      isCronometroPaused: false,
    };
  },
  computed: {
    ...mapGetters({
      tarjaParams: "tarja_cronometro/getTarjaParams",
      configTarja: "tarja_cronometro/getConfigTarja",
    }),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  methods: {
    formatDate,
    formatHour,
    ...mapActions({
      getConfigTarja: "tarja_cronometro/getConfigTarjaCronometro",
      assignTarjaParams: "tarja_cronometro/assignTarjaParams",
    }),
    handleClickPlayPause() {
      if (!this.isCronometroPaused) {
        localStorage.setItem("@socialcam/isCronometroPaused", true);
        this.isCronometroPaused = true;
        return;
      }
      localStorage.setItem("@socialcam/isCronometroPaused", false);
      this.isCronometroPaused = false;
      return;
    },
    handleResetTimerCronometro() {
      localStorage.setItem("@socialcam/resetTimer", true);
    },
    async showModalImagem(midia_url_aprovadas) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async changeIsSelectedToTarja(id_cronometro, cod_producao) {
      await apiClient
        .patch(`setCronometroExibicaoTarja/${cod_producao}`, {
          id_cronometro,
        })
        .catch((error) => {
          console.error(error);
          this.$toast.error("Erro ao exibir cronômetro na tarja");
        })
        .then(async () => {
          await this.getConfigTarja({ cod_producao: this.item.cod_producao });
        });
    },
    async removerCronometroExibicao() {
      const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;
      const wasOnTarja = this.configTarja && this.configTarja.id_cronometro === this.item.id;

      await apiClient
        .patch(
          `/cronometro/removerCronometroExibicao/${this.item.id}/${cod_producao}`
        )
        .then(async () => {
          if (wasOnTarja) {
            this.assignTarjaParams(null);
            localStorage.removeItem("tarjaParams");
            await this.getConfigTarja({ cod_producao });
          }
          await this.getCronometroEmExibicao({
            cod_producao,
          });
          await this.getCronometrosProducao({
            cod_producao,
            flg_favorita: this.$store.state.cronometros.flg_favorita,
            page: this.$store.state.cronometros.cronometrosProducao.currentPage,
            size: 5,
            filtro_texto: this.$store.state.cronometros.filtroCronometros,
            cod_pasta: this.cod_pasta,
          });
          this.$toast.success("Cronômetro removido da exibição com sucesso!");
        })
        .catch((error) => {
          console.error(error);
          this.$toast.error("Houve um erro ao remover o cronômetro moderado");
          this.dialogRemoverNoticiaModerada = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.cronometro-timer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  flex: 1;
}

.cronometro-timer__display {
  font-size: 3.5rem;
  font-weight: 600;
  color: var(--v-text_primary-base);
  letter-spacing: 2px;
  line-height: 1;
}
</style>
